import get from 'lodash/get';

import { isColumn } from '@lumapps/wrex-columns/utils/isColumn';
import { Path, Transforms, type Point, type ReactEditor } from '@lumapps/wrex/slate';
import { findParent } from '@lumapps/wrex/slate/utils/findParent';
import { focusAt } from '@lumapps/wrex/slate/utils/focusAt';
import { getSiblingPath } from '@lumapps/wrex/slate/utils/getSibling';
import { isSelectionEmpty } from '@lumapps/wrex/slate/utils/isSelectionEmpty';

import type { TypographyEditor } from '../types';
import { createDivider } from './createDivider';

/**
 * Insert divider after editor selection
 */
export function insertDivider(editor: ReactEditor & TypographyEditor, point?: Point | undefined) {
    const at = point || editor.selection?.focus;

    const canInsertOnSelection = at && isSelectionEmpty(editor, at.path);

    const columnParent = findParent(editor, at?.path, (node) => isColumn(node));

    let insertionPath;
    let afterPath;

    if (!columnParent) {
        const after = getSiblingPath([get(at, ['path', 0]) as number], 'after');
        insertionPath = canInsertOnSelection ? [at.path[0]] : after;
        afterPath = after;
    } else {
        const currentPath = (at?.path || []).slice(0, 3);
        const after = Path.next(currentPath);
        insertionPath = canInsertOnSelection ? currentPath : after;
        afterPath = after;
    }

    Transforms.insertNodes(editor, createDivider(), {
        at: insertionPath ?? [editor.children.length],
    });

    // all inserted divider has paragraph added after, so we focus the paragraph
    focusAt(editor, afterPath);

    return afterPath ?? [editor.children.length];
}
